import { useMemo } from "react";
import { NFTContract } from "../types";
import { createRouteFromParams } from "@/src/helpers/createRouteWithParams";
import { ROUTE_TOKEN_LISTING_PAGE } from "@/constants/routes";
import { getProductName } from "../helpers";

export function useDefendNftFromMissingMetadata(
  nft: NFTContract,
  swooshHandle: string,
): { defendedLink: string } {
  const defendedLink = useMemo(() => {
    /** Defend against cases where backend provides partial data */
    if (!nft.collectionSlug || !nft.productSlug || !nft.tokenId) return "";

    return createRouteFromParams(ROUTE_TOKEN_LISTING_PAGE, {
      collectionName: nft.collectionSlug as string,
      productName: getProductName(
        nft.collectionSlug,
        nft.productSlug,
        swooshHandle,
      ),
      tokenId: nft.tokenId as string,
    });
  }, [nft.productSlug, nft.collectionSlug, nft.tokenId, swooshHandle]);

  return { defendedLink };
}
